import {makeAutoObservable} from "mobx"

import {GridDataEntry} from "controls/grid/gridDataEntry"
import {GridStore} from "controls/grid/gridStore"
import {GridViewSelectorProps} from "controls/grid/viewManager/gridViewSelectorProps";
import React from "react";
import {Divider, Typography} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import {i18n} from "core/localization";

const b = require('b_').with('grid-view-manager')

export type ViewManagerProps<T extends GridDataEntry> = {
	store: ViewManagerStore<T>
}

export class ViewManagerStore<T extends GridDataEntry> {
	showDetails: boolean
	nameEditing: boolean
	originalName: string
	currentTab: string = "filters"
	props: GridViewSelectorProps<T>

	constructor() {
		makeAutoObservable(this)
	}

	init(){

	}

	get gridStore(){
		return this.props?.store
	}

	get isFavorite() {
		return this.gridStore.state.initialViewId == this.gridStore.state.currentViewId
	}

	addView = () => {
		this.gridStore.state.duplicateCurrentView()
		this.showDetails = true
		this.currentTab = 'enabled-columns'
	}

	deleteView = () => {
		this.gridStore.state.deleteView()
		this.showDetails = false
	}

	setFavorite = () => {
		this.gridStore.state.initialViewId = this.gridStore.state.currentViewId
	}

	editName = () => {
		this.originalName = this.gridStore.state.currentView.name
		this.nameEditing = true
	}

	cancelEditing = () => {
		this.gridStore.state.currentView.name = this.originalName
		this.confirmNameChange()
	}

	confirmNameChange = () => {
		if (!this.gridStore.state.currentView.name.trim()) {
			this.gridStore.state.currentView.name = this.originalName
		}

		this.originalName = null
		this.nameEditing = false
	}

	get dropdownRender(){
		return (menu: React.ReactElement) => {
			return <>
				{menu}

				{this.props.createViewDisabled !== true && <>
					<Divider className={b('divider')}/>

					<Typography.Link className={b('add-button')} onClick={this?.addView}>
						<PlusOutlined/> {i18n('Add View')}
					</Typography.Link>
				</>}
			</>
		}
	}


	toggleDetails = () => {
		this.showDetails = !this.showDetails
	}

	closeDetails = () => {
		this.showDetails = false
	}
}
